import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d9e8ed;
  z-index: 1200;
  video {
    transform: scale(0.5)
  }
`;

const LoaderComponent = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    document.getElementById('myVideo').play();
    document.getElementById('myVideo').addEventListener('ended',myHandler,false);
    function myHandler(e) {
      setShow(false);
    }

    setTimeout(()=>setShow(false),10000)
  }, []);

  return (
    <>
      {show && (
        <Container>
            <video muted autoPlay poster="/assets/LogoBlack.png" id="myVideo" >
              <source src="/assets/introVideo.mp4" type="video/mp4"/>
            </video>
        </Container>
      )}
    </>
  );
};

export default LoaderComponent;
